import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import Button from '../../../../../../components/global/Button';
import getConfig from '../../../../../../util/config';

const propTypes = {
  rosterQrCodeId: PropTypes.string.isRequired,
  fileName: PropTypes.string,
};

// The canvas is rendered at print resolution so the downloaded PNG stays
// sharp, and scaled down to the avatar size for display.
const QR_CODE_SIZE = 500;
const QR_CODE_DISPLAY_SIZE = 72;

const RosterIdentityQrCodeDownload = ({ rosterQrCodeId, fileName }) => {
  const { app } = getConfig();

  const canvasId = `roster-identity-qr-code-${rosterQrCodeId}`;

  const onDownload = () => {
    // Can't use ref here cause qrcode.react does not support it :shrug:
    const canvas = document.getElementById(canvasId);

    if (!canvas) {
      return;
    }

    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${fileName || 'QR code'}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Button
      btnStyle="reset"
      className="roster-identity-qr-code-download p-0"
      onClick={onDownload}
      aria-label="Download QR code"
      title="Download QR code"
    >
      <QRCode
        id={canvasId}
        value={`${app?.baseUrl}/rqr/${rosterQrCodeId}`}
        renderAs="canvas"
        size={QR_CODE_SIZE}
        style={{ width: QR_CODE_DISPLAY_SIZE, height: QR_CODE_DISPLAY_SIZE }}
      />
    </Button>
  );
};

RosterIdentityQrCodeDownload.propTypes = propTypes;

export default RosterIdentityQrCodeDownload;
